export default{
  "terms.title": "Terms and Conditions of Sale",
  "terms.section1.title": "1. Purpose",
  "terms.section1.content": "These terms govern sales made on the Eatorder platform between partner sellers and buyers.",
  "terms.section2.title": "2. Orders",
  "terms.section2.content": "The buyer selects a product, places an order, and completes the payment. A confirmation is sent by email. The seller is responsible for shipping and delivery.",
  "terms.section3.title": "3. Prices",
  "terms.section3.content": "All prices are displayed in euros, inclusive of all taxes (VAT). Shipping fees are added during the checkout process.",
  "terms.section4.title": "4. Payment",
  "terms.section4.content": "Payments are securely processed through <strong>Stripe</strong> and/or <strong>PayPal</strong>. No banking information is stored on our servers.",
  "terms.section5.title": "5. Delivery",
  "terms.section5.content": "Delivery is handled by partner sellers according to the timeframes indicated on the product pages.",
  "terms.section6.title": "6. Right of Withdrawal",
  "terms.section6.content": "In accordance with applicable law, buyers have a 14-day period to withdraw from the purchase starting from the date of receipt (except for non-refundable products).",
  "terms.section7.title": "7. Customer Service",
  "terms.section7.content": "For any questions or complaints, please contact us at: support@eatorder.com",
  "terms.section8.title": "8. Liability",
  "terms.section8.content": "Eatorder is not liable for disputes between buyers and sellers. We only act as an intermediary platform.",
  "terms.section9.title": "9. Governing Law",
  "terms.section9.content": "These terms are governed by French law. In case of a dispute, the competent court shall be that of the registered office of Eatorder.",

   "privacy.title": "Privacy Policy",
  "privacy.intro": "We are committed to protecting your privacy. This policy explains how we collect, use, share, and protect your personal data on our marketplace platform Eatorder.",
  "privacy.section1.title": "1. Data Collected",
  "privacy.section1.items": [
    "Identification information: full name, email address, phone number",
    "Payment details via third-party providers (e.g., Stripe, PayPal)",
    "Browsing data: IP address, cookies, visited pages"
  ],
  "privacy.section2.title": "2. Use of Data",
  "privacy.section2.intro": "Your data is used to:",
  "privacy.section2.items": [
    "Process orders and manage deliveries",
    "Maintain your account and preferences",
    "Send notifications and updates (with consent)",
    "Improve service functionality and performance"
  ],
  "privacy.section2.legal": "<strong>Legal basis:</strong> contract fulfillment, user consent, and legitimate interest.",
  "privacy.section3.title": "3. Data Sharing",
  "privacy.section3.intro": "Data is shared with:",
  "privacy.section3.items": [
    "Payment processors",
    "Shipping and logistics providers",
    "Hosting and infrastructure services"
  ],
  "privacy.section4.title": "4. Your Rights",
  "privacy.section4.intro": "Under GDPR, you have rights to:",
  "privacy.section4.items": [
    "Access, correct, or delete your data",
    "Restrict or object to data processing",
    "Port your data to another provider"
  ],
  "privacy.section4.contact": "Contact: support@eatorder.com",
  "privacy.section5.title": "5. Cookies",
  "privacy.section5.content": "We use cookies for core functionality and analytics. You can modify cookie preferences in your browser.",
  "privacy.section6.title": "6. Data Security",
  "privacy.section6.content": "Security measures include encryption, access restrictions, and regular backups to protect your data.",
  "privacy.section7.title": "7. Data Retention",
  "privacy.section7.content": "Data is retained as long as necessary for service delivery and for up to 3 years after your last activity.",
  "privacy.section8.title": "8. Contact",
  "privacy.section8.content": "For questions or privacy-related concerns, contact support@eatorder.com.",

  "slogan.main": "Savor the Moment on EatOrder",
  "slogan.sub": "Every Bite, a Flavorful Experience",
}
